import BaseView from './utilities/baseView.js';
import Gallery from './utilities/gallery.js';
import SliderCounter from './utilities/slider-counter.js';
import Selectpicker from './utilities/selectpicker.js';
import AgreementsModule from './modules/Apartment/agreementsModule.js';
import ImagesSliderModule from './modules/Apartment/imagesSliderModule.js';
import ReservationFormModule from './modules/Apartment/reservationFormModule.js';
import AddonsModule from './modules/Apartment/addonsModule.js';
import ReservationCalculatorModule from './modules/Apartment/reservationCalculatorModule.js';

class ApartmentView extends BaseView {

    initialData = null;
    localeSettings = {
        OPERATION_PLUS: 'plus',
        OPERATION_MINUS: 'minus',
        skipLogin: false,
        currency: null,
        rentalValueName: '',
        bundleStr: '',
        reservationStep: 0,
        activeSwitcherBox: 0,
        checkUserEmailExistsUrl: null,
        checkDiscountCodeUrl: null,
        currentUserIsInLoyaltyProgram: false,
        loyaltyProgramDiscount: 0,
        currentUserId: -1,
        regex: {
            email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,40})$/,
            phoneNumber: /^[- +()]*[0-9][- +()0-9]{5,18}$/,
            taxNumber: /^[0-9\-]{10,20}$/,
            postCode: /^[A-Za-z0-9-]{4,8}$/
        }
    };

    sliderCounter = null;
    selectpicker = null;
    gallery = null;

    imagesSliderModule = null;
    agreementsModule = null;
    addonsModule = null;
    reservationFormModule = null;

    constructor() {
        super(apartmentConfig);
        this.prepareLocaleConfig(apartmentConfig);
        this.sliderCounter = new SliderCounter();
        this.selectpicker = new Selectpicker();
        this.gallery = new Gallery(this.settings('gallery'));
        this.imagesSliderModule = new ImagesSliderModule(this.gallery);
        this.agreementsModule = new AgreementsModule();
        this.addonsModule = new AddonsModule(
            apartmentConfig.addons,
            this.settings('currency'),
            this.initialData
        );
        this.calculator = new ReservationCalculatorModule(
            this.localeSettings,
            this.initialData,
            this.localeData,
            this.notification,
            this.addonsModule.addons
        );
        this.addonsModule.setCalculator(this.calculator);
        this.reservationFormModule = new ReservationFormModule(
            this.initialData,
            this.calculator,
            this.agreementsModule,
            this.localeSettings,
            this.localeData,
            this.notification
        );
        this.prepareLoginModal();
        this.bindToggleDetailsButton();
        this.bindToggleIconsButton();
    }

    prepareLocaleConfig = (config) => {
        if (typeof config.initialData === 'object') {
            this.initialData = config.initialData;
        }

        if (typeof config.settings === 'object') {
            for (const [key, value] of Object.entries(this.localeSettings)) {
                if (typeof config.settings[key] === 'string' || typeof config.settings[key] === 'number') {
                    this.localeSettings[key] = config.settings[key];
                }
            }
        }
    }

    prepareLoginModal = () => {
        const modalContainer = document.getElementById('loginModal');
        const buttonsContainer = modalContainer.querySelector('.auth-form__buttons');
        buttonsContainer.classList.add('auth-form__buttons__buttons--skip-login');

        const button = document.createElement('button');
        button.type = 'button';
        button.classList.add('button', 'button--secondary');
        button.innerText = this.locale("buttonContinueWithoutLogin");

        button.addEventListener('click', () => {
            modal.close('login');
            this.localeSettings.skipLogin = true;
        });

        buttonsContainer.appendChild(button);
    }

    bindToggleDetailsButton = () => {
        const container = document.querySelector('.rent-summary-list__container');
        const button = document.getElementById('detailsToggle');

        button.addEventListener('click', () => {
            if (this.initialData.bundleId != null) {
                modal.open('bundle-info');
            } else {
                button.classList.toggle('active');
                container.classList.toggle('active');
            }
        });
    }

    bindToggleIconsButton = () => {
        const iconsContainers = document.querySelectorAll('.apartment-description-list__icons');

        iconsContainers.forEach(iconsContainer => {
            const button = iconsContainer.parentElement.querySelector('.apartment-description-list__toggle');
            if (iconsContainer.childElementCount <= 3) {
                button.remove();
            } else {
                button.addEventListener('click', () => {
                    button.classList.toggle('open');
                    iconsContainer.classList.toggle('open');
                });
            }
        });
    }
}

new ApartmentView();